export const DASHBOARD_SECTION_IDS = {
  STATS_CARDS: 'stats-cards',
  ACCOUNTING_OVERVIEW: 'accounting-overview',
  ASSIGNMENTS_OVERVIEW: 'assignments-overview',
  DEALS_OVERVIEW: 'deals-overview',
  CLIENTS_OVERVIEW: 'clients-overview',
};
